var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEyesClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.72655 14.2794C4.18905 13.1877 2.97239 11.7677 2.28489 10.871C2.09264 10.6235 1.98828 10.319 1.98828 10.0056C1.98828 9.69222 2.09264 9.38773 2.28489 9.14021C3.52905 7.51604 6.51405 4.17188 9.99905 4.17188C11.5624 4.17188 13.0241 4.84438 14.2741 5.73354",
    stroke: "#CCCCCC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7745 8.23908C11.5431 8.00381 11.2674 7.81668 10.9633 7.68849C10.6592 7.5603 10.3327 7.49359 10.0027 7.49221C9.67265 7.49083 9.34562 7.5548 9.04045 7.68043C8.73529 7.80607 8.45801 7.99088 8.22463 8.22421C7.99124 8.45754 7.80637 8.73477 7.68066 9.03991C7.55495 9.34505 7.4909 9.67206 7.49221 10.0021C7.49351 10.3321 7.56014 10.6586 7.68826 10.9627C7.81638 11.2668 8.00344 11.5426 8.23866 11.7741",
    stroke: "#CCCCCC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33203 16.6693L16.6654 3.33594",
    stroke: "#CCCCCC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33203 15.5867C8.87304 15.7477 9.43424 15.8308 9.9987 15.8333C13.4837 15.8333 16.4687 12.4892 17.7129 10.865C17.9051 10.6173 18.0093 10.3126 18.0092 9.99902C18.009 9.68547 17.9045 9.38089 17.712 9.13333C17.2748 8.56291 16.8057 8.0176 16.307 7.5",
    stroke: "#CCCCCC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEyesClose);
export default __webpack_public_path__ + "static/media/icon-eyes-close.7f21f01ecbc88a36d5640dfebe362f0f.svg";
export { ForwardRef as ReactComponent };